import React from "react";
export function useRouteRender() {
  const [routeRender, setRouteRender] = React.useState(null);
  React.useEffect(() => {
    const listener = event => {
      setRouteRender(event.detail);
    };
    window.addEventListener("route.render", listener);
    return () => window.removeEventListener("route.render", listener);
  }, []);
  return routeRender;
}
//# sourceMappingURL=useRouteRender.js.map